// extracted by mini-css-extract-plugin
export default {"right-box":"right-box--nmXr5","right-icon":"right-icon--ellvl","right-text-icon":"right-text-icon--iV4BL"};